<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div id="select_store">
      <div class="store_container">
        <h2>事業所選択</h2>
        <div name="form-passmod" class="form">
          <div class="err_message" v-if="isError">
            選択する事業所は5件以内にしてください。
          </div>
          <div style="height: 250px; overflow-x: hidden; overflow-y: auto; margin-bottom: 30px;">
            <table>
              <thead>
                <tr>
                  <th>選択</th>
                  <th>お客さま名</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in dispStoreList" v-bind:key="index">
                  <td><input type="checkbox" v-model="selected" v-bind:value="item.account"></td>
                  <td>{{ item.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="submit_area">
            <input
              type="submit"
              class="submit"
              value="事業所選択"
              @click="onSelect"
            />
            <input
              type="button"
              class="cancel"
              value="キャンセル"
              @click="onCancel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "select-store",
  props: ["account"],
  data: function() {
    return {
      selected: [],
      dispStoreList: [],
      isError: false
    };
  },
  watch: {
    selected: function(newValue, oldValue) {
      console.log("selected");
      console.log(this.selected);
      if (this.selected.length > 5) {
        this.isError = true;
      } else {
        this.isError = false;
      }
    }
  },
  computed: {
  },
  mounted: function() {
    console.log("SelectStore:mounted");

    this.$axios
      .get(`/srv/api/select_store/${this.account}`, {
        withCredentials: true
      })
      .then(response => {
        console.log("select_store success");
        console.log(response.data);
        if (typeof response.data == "object") {
          this.dispStoreList = response.data.store_list;
          console.log(this.dispStoreList);
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log("select_store error");
        console.log(error);
      });
  },
  methods: {
    onSelect: function() {
      console.log("onSelect");
      if (this.isError) {
        alert("選択事業所数を5件以内にしてください。");
        return;
      }

      let storeList = [];
      for (let i = 0; i < this.selected.length; i++) {
        let targetAccount = "";
        let targetName = "";
        for (let j = 0; j < this.dispStoreList.length; j++) {
            if (this.selected[i] == this.dispStoreList[j].account) {
                targetAccount = this.dispStoreList[j].account;
                targetName = this.dispStoreList[j].name;
                break;
            }
        }
        let storeInfo = {
          name: targetName,
          account: targetAccount
        };
        storeList.push(storeInfo);
      }

      this.$parent.selectedStore = storeList;
      this.$emit("close");
    },
    onCancel: function() {
      console.log("onCancel");
      this.$emit("close");
    }
  }
};
</script>
